module.exports = __webpack_public_path__ + "eede72cc76b10d7b04fd85cfdf8e084a.fbx";